import { render, staticRenderFns } from "./HotTag.vue?vue&type=template&id=325e558e&scoped=true"
import script from "./HotTag.vue?vue&type=script&lang=js"
export * from "./HotTag.vue?vue&type=script&lang=js"
import style0 from "./HotTag.vue?vue&type=style&index=0&id=325e558e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325e558e",
  null
  
)

export default component.exports